import React from 'react';
import RoomEntry from './RoomEntry';

const Home = () => (
  <>
    <RoomEntry />
  </>
);

export default Home;
